import Page from '@components/Page';
import Container from '@mui/material/Container';
import { NextPage } from 'next';
import ForCorporateHeader from '@components/for-corporate/ForCorporateHeader';
import ForCorporateContactUs from '@components/for-corporate/ForCorporateContactUs';
import Footer from '@components/Footer';

const ForCorporatePage: NextPage = () => {
  return (
    <Page isLayerOnePage bgcolor={'#fafafa'} title="For Corporate | Potioneer">
      <ForCorporateHeader backgroundImg="https://images.potioneer.com/images-for-corporate/BG_rseJz3PjW.webp" />
      <Container>
        <ForCorporateContactUs />
        <Footer isFullFooter />
      </Container>
    </Page>
  );
};

export default ForCorporatePage;
